import { geoService } from '../../services'

const state = {
  allCities: {}
}

const actions = {
  getAllCities ({ commit }) {
    commit('getAllCitiesRequest')
    return geoService.getAllCities()
      .then(
        cities => {
          commit('getAllCitiesSuccess', cities)
          return cities
        },
        error => commit('getAllCitiesFailure', error)
      )
  },
  addNewCity ({ commit }, cityName) {
    commit('addNewCityRequest')
    return geoService.addNewCity(cityName)
      .then(
        cities => {
          return cities
        },
        error => commit('addNewCityFailure', error)
      )
  }
}

const mutations = {
  getAllCitiesRequest (state) {
    state.allCities = { loading: true }
  },
  getAllCitiesSuccess (state, cities) {
    state.allCities = { items: cities }
  },
  getAllFailure (state, error) {
    state.allCities = { error }
  },
  addNewCityRequest (state) {
    state.allCities = { loading: true }
  }
}

export const geo = {
  namespaced: true,
  state,
  actions,
  mutations
}
